import { SELECT_TAB } from './constants'

export const selectTab = tabIndex => ({
  type: SELECT_TAB,
  tabIndex,
})
